<template>
  <div class="rm-screen">
    <div
      class="rm-segment"
      role="tablist"
      :aria-label="$t('shifts')"
    >
      <button
        v-for="segment in segments"
        :key="segment.key"
        type="button"
        role="tab"
        class="rm-segment__btn"
        :class="{ 'is-active': segment.active }"
        :aria-selected="String(segment.active)"
        @click="$emit('update:shifts', segment.shifts)"
      >
        {{ segment.label }}
      </button>
    </div>

    <div class="rm-summary">
      <div class="rm-summary__row">
        <div class="rm-summary__labels">
          <span>{{ summaryLabel }}</span>
        </div>
        <span class="rm-summary__value">{{ visibleTotal }}</span>
      </div>
    </div>

    <div v-if="!selectedCompanies.length" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-domain</v-icon>
      {{ $t("no_companies_selected") }}
    </div>
    <div v-else-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <template v-else-if="rows.length">
      <button
        v-for="row in rows"
        :key="row.id"
        type="button"
        class="rm-meal-row"
        @click="$emit('open-screen', 'workerOrders', { search: row.name })"
      >
        <span class="rm-meal-row__text">
          <span class="rm-meal-row__name">{{ row.name }}</span>
        </span>
        <span class="rm-meal-row__count rm-num">{{ row.count }}</span>
        <v-icon size="18" color="#8a817a">mdi-chevron-right</v-icon>
      </button>
    </template>
    <div v-else class="rm-empty">{{ emptyText }}</div>
  </div>
</template>

<script>
import ReportMealsTabMeals from "@/components/report/meals/tabs/ReportMealsTabMeals.vue";
import { SHIFTS } from "@/constants/shifts";
import hasShiftSegments from "../hasShiftSegments";

/**
 * Mobilni prikaz "Obroci": nasleđuje učitavanje, štampu i Excel iz ReportMealsTabMeals.
 */
export default {
  name: "ReportMobileMeals",
  extends: ReportMealsTabMeals,
  mixins: [hasShiftSegments],
  props: {
    shifts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    shiftTotals() {
      return SHIFTS.reduce((totals, shift) => {
        totals[shift.id] = this.meals.reduce((sum, meal) => sum + (meal[shift.key] || 0), 0);
        return totals;
      }, {});
    },
    visibleTotal() {
      return this.totalShiftMeals("total");
    },
    rows() {
      const searched = this.customSearch(
        this.filteredMeals,
        [{ value: "name" }],
        this.filters.search
      );
      return searched
        .filter((meal) => meal.total > 0)
        .map((meal) => ({
          id: meal.id,
          name: meal.name,
          count: meal.total,
        }))
        .sort((a, b) => b.count - a.count);
    },
    emptyText() {
      if (this.filters.search) {
        return this.$t("report_mobile.no_results_for", { search: this.filters.search });
      }
      return this.isSingleShift
        ? this.$t("report_mobile.no_meals_in_shift")
        : this.$t("report_mobile.no_meals");
    },
  },
  watch: {
    shifts: {
      handler(shifts) {
        this.selectedShifts = [...shifts];
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.rm-theme .rm-meal-row {
  width: 100%;
  min-height: 68px;
  padding: 14px 14px 14px 16px;
  border: 1px solid var(--rm-border);
  border-radius: 16px;
  background: var(--rm-surface);
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  color: var(--rm-text);

  &:active {
    background: var(--rm-bg);
  }

  &__text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__name {
    font-size: 16px;
    font-weight: 600;
  }

  &__count {
    font-size: 26px;
    font-weight: 700;
  }
}
</style>
